import { defineMessages } from 'react-intl';

export default defineMessages({
  wixVideo: {
    id: 'shared.wix-video',
    defaultMessage: 'Wix Video',
  },

  channels: {
    id: 'shared.channels',
    defaultMessage: 'Channels',
  },
  channelInfo: {
    id: 'shared.channel-info',
    defaultMessage: 'Channel info',
  },
  videoLibrary: {
    id: 'shared.video-library',
    defaultMessage: 'Video Library',
  },
  stats: {
    id: 'shared.stats',
    defaultMessage: 'Stats',
  },
  overview: {
    id: 'shared.overview',
    defaultMessage: 'Overview',
  },
  videos: {
    id: 'shared.videos',
    defaultMessage: 'Videos',
  },
  settings: {
    id: 'shared.settings',
    defaultMessage: 'Settings',
  },
  preview: {
    id: 'shared.preview',
    defaultMessage: 'Preview',
  },
  upgrade: {
    id: 'shared.upgrade',
    defaultMessage: 'Upgrade',
  },
  upgradeNow: {
    id: 'shared.upgrade-now',
    defaultMessage: 'Upgrade Now',
  },
  help: {
    id: 'shared.help',
    defaultMessage: 'Help',
  },
  feedback: {
    id: 'shared.feedback',
    defaultMessage: 'Feedback',
  },
  free: {
    id: 'shared.free',
    defaultMessage: 'Free',
  },
  memberOnly: {
    id: 'shared.member-only',
    defaultMessage: 'Free with sign up',
  },
  sale: {
    id: 'shared.sale',
    defaultMessage: 'Buy',
  },
  saleWithPrice: {
    id: 'shared.sale-with-price',
    defaultMessage: '{price} Buy',
  },
  rent: {
    id: 'shared.rent',
    defaultMessage: 'Rent',
  },
  rentWithPrice: {
    id: 'shared.rent-with-price',
    defaultMessage: '{price} Rent',
  },
  no: {
    id: 'shared.no',
    defaultMessage: 'No',
  },
  yes: {
    id: 'shared.yes',
    defaultMessage: 'Yes',
  },
  cancel: {
    id: 'shared.cancel',
    defaultMessage: 'Cancel',
  },
  save: {
    id: 'shared.save',
    defaultMessage: 'Save',
  },
  delete: {
    id: 'shared.delete',
    defaultMessage: 'Delete',
  },
  change: {
    id: 'shared.change',
    defaultMessage: 'Change',
  },
  remove: {
    id: 'shared.remove',
    defaultMessage: 'Remove',
  },
  edit: {
    id: 'shared.edit',
    defaultMessage: 'Edit',
  },
  videosCount: {
    id: 'shared.videosCount',
    defaultMessage: '{videosCount, plural, =0 {No videos} =1 {1 Video} other {# Videos}}',
  },
  moviesCount: {
    id: 'shared.movies-count',
    defaultMessage: '{moviesCount, plural, =0 {No movies} =1 {1 Movie} other {# Movies}}',
  },
  subscription: {
    id: 'shared.subscription',
    defaultMessage: 'Subscription',
  },
  price: {
    id: 'shared.price',
    defaultMessage: 'Price',
  },
  period: {
    id: 'shared.period',
    defaultMessage: 'Period',
  },
  new: {
    id: 'shared.new',
    defaultMessage: 'New',
  },
  uploading: {
    id: 'shared.uploading',
    defaultMessage: 'Uploading...',
  },
  featuredVideo: {
    id: 'shared.featured-video',
    defaultMessage: 'Featured video',
  },
  required: {
    id: 'shared.required',
    defaultMessage: 'Required',
  },
});



// WEBPACK FOOTER //
// ./src/shared/translations/index.js